import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DeleteChannelMutationVariables = Types.Exact<{
  data: Types.RemoveChannelsInput;
}>;


export type DeleteChannelMutation = { removeChannels?: { success?: boolean | null } | null };


export const DeleteChannelDocument = /*#__PURE__*/ gql`
    mutation deleteChannel($data: RemoveChannelsInput!) {
  removeChannels(data: $data) {
    success
  }
}
    `;

export function useDeleteChannelMutation() {
  return Urql.useMutation<DeleteChannelMutation, DeleteChannelMutationVariables>(DeleteChannelDocument);
};